import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import queryString from "querystring";

import { Layout } from "antd";

// import {setLoading} from "../../redux/store/common/commonDuck";
import partnersApi from "../../apis/Partners.api";
import PartnersApi from "../../apis/Partners.api";
import { setReduxChannel } from "../../redux/store/channel/channelDuck";
import HomeGroupBuyingAlert from "../channel/home/HomeGroupBuyingAlert";
import MetaTag from "../MetaTag";

import ChannelFooter from "./ChannelFooter";
import ChannelHeader from "./ChannelHeader";
import ContentComponent from "./ContentComponent";
import FooterComponent from "./FooterComponent";
import HeaderComponent from "./HeaderComponent";

const { Header, Footer, Content } = Layout;

const PageLayout = () => {
	const history = useHistory();
	const location = useLocation();
	const dispatch = useDispatch();

	const setChannel = (value) => dispatch(setReduxChannel(value));

	const [channelInfo, setChannelInfo] = useState({});
	const queryJson = queryString.parse(location.search?.replace("?", ""));
	const channelId = queryJson?.id?.replace(".html", "");

	// const user = useSelector(state => state.auth.user)
	// const cUser = useSelector(state => state.auth.channelUser);
	// console.log(user);
	// console.log(cUser);

	const [clear, setClear] = useState(false);
	useEffect(() => {
		if (!clear) {
			setChannelInfo({});
			setChannel({});
			setClear(true);
		}
	}, [clear]);

	// useEffect(() => {
	//     if (channelInfo?.influencer_id !== channelId) {
	//         setChannelInfo({});
	//         setChannel({});
	//     }
	// }, [channelInfo]);

	const sessionItem = sessionStorage.getItem("influencer");
	useEffect(() => {
		if (channelId) {
			if (
				channelInfo?.influencer_id !== channelId &&
				channelInfo?.influencer_id !== sessionItem
			) {
				getInfoDefault();
				sessionStorage.setItem("influencer", channelId);
			}
		}
		// if (!sessionItem) {
		//     setChannelInfo({});
		//     setChannel({});
		// }
		// else {
		//     if (!reduxChannel?.id) {
		//         history.replace("/");
		//     }
		// }
	}, [location, channelId, channelInfo, sessionItem]);

	const getInfoDefault = async () => {
		let param = {
			query: channelId,
			offset: 0,
			pageSize: 3,
		};
		const res = await PartnersApi.getChannel(param);
		if (res.code === 200) {
			const rsq = await partnersApi.getUserInfo({
				userId: res.result?.user_id,
			});
			const rsp = await partnersApi.getMenuChannel({
				influencerId: res.result?.user_id,
			});
			if (rsq.code === 200 && rsp.code === 200) {
				setChannelInfo({
					...res.result,
					name: rsq.result?.name,
					inquiry_link: rsq.result?.inquiry_link,
					youtube_link: rsq.result?.youtube_link,
					instagram_link: rsq.result?.instagram_link,
					ingredient_menu_show: rsp.result?.ingredient_menu_show,
					function_menu_show: rsp.result?.function_menu_show,
					combination_menu_show: rsp.result?.combination_menu_show,
					inquiry_menu_show: rsp.result?.inquiry_menu_show,
					quick_menu_show: rsp.result?.quick_menu_show,
					greetings1: rsp.result?.greetings1,
					greetings2: rsp.result?.greetings2,
					greetings3: rsp.result?.greetings3,
					greetings4: rsp.result?.greetings4,
					email: rsq.result?.user_id,
					placeholder: rsq.result?.placeholder,
				});
				setChannel({
					...res.result,
					name: rsq.result?.name,
					inquiry_link: rsq.result?.inquiry_link,
					youtube_link: rsq.result?.youtube_link,
					instagram_link: rsq.result?.instagram_link,
					ingredient_menu_show: rsp.result?.ingredient_menu_show,
					function_menu_show: rsp.result?.function_menu_show,
					combination_menu_show: rsp.result?.combination_menu_show,
					inquiry_menu_show: rsp.result?.inquiry_menu_show,
					quick_menu_show: rsp.result?.quick_menu_show,
					greetings1: rsp.result?.greetings1,
					greetings2: rsp.result?.greetings2,
					greetings3: rsp.result?.greetings3,
					greetings4: rsp.result?.greetings4,
					email: rsq.result?.user_id,
					placeholder: rsq.result?.placeholder,
				});
			} else {
				setChannelInfo({});
				setChannel({});
				history.replace("/404");
			}
		} else {
			setChannelInfo({});
			setChannel({});
			history.replace("/404");
		}
	};

	return (
		<>
			<MetaTag
				title={channelInfo?.nickname ?? null}
				description={
					channelInfo?.nickname
						? `${channelInfo?.nickname + " 홈페이지 입니다."}`
						: null
				}
				keywords={`약사, ${channelInfo?.nickname}, ${channelInfo?.name}, 홈페이지`}
				image={`/${channelInfo?.influencer_id}.jpg`}
				url={`https://together.dangyoung.com/together/channel?id=${channelInfo?.influencer_id}`}
			/>
			<Layout style={{ minHeight: "100%" }}>
				{location.pathname !== "/404" && (
					<Header
						className={`header together-header-height ${
							location.pathname === "/" ? "together-header" : ""
						}`}
						style={
							!(
								location.pathname.includes("/channel") &&
								!location.pathname.includes("/edit")
							)
								? { padding: 0 }
								: { padding: "2em" }
						}
					>
						{location.pathname.includes("@") ||
						(location.pathname.includes("/channel") &&
							!location.pathname.includes("/edit")) ? (
							<>
								{!!channelInfo?.influencer_id && (
									<ChannelHeader channelInfo={channelInfo} />
								)}
								{!!location.pathname.includes("@") && (
									<ChannelHeader channelInfo={channelInfo} />
								)}
							</>
						) : (
							<HeaderComponent />
						)}
					</Header>
				)}
				<Content
					className="content"
					style={
						location.pathname.includes("/dashboard")
							? {
									backgroundColor: "#f8f9fa",
							  }
							: {}
					}
				>
					<ContentComponent channelInfo={channelInfo} />
					{/*{user && accessToken && refreshToken ?*/}
					{/*    <ContentComponent />*/}
					{/*    : <SignInComponent />*/}
					{/*}*/}
				</Content>

				{location.pathname.includes("/together/channel") ? (
					<>
						{/* 하단 공동구매 놓치지 마세요*/}
						{!!channelInfo?.influencer_id &&
							!location.pathname.includes("/community") &&
							!location.pathname.includes("/communities") &&
							!location.pathname.includes("/login") &&
							!location.pathname.includes("/signup") &&
							!location.pathname.includes("/find/user") &&
							!location.pathname.includes("/policy") &&
							!location.pathname.includes("/terms") &&
							channelInfo?.user_id !== 1 &&
							channelInfo?.user_id !== 9 && (
								// && !location.pathname.includes("/inquiry/board")
								<>
									<HomeGroupBuyingAlert />
									{/*{channelInfo?.user_id === 7 && (*/}
									<Footer className="footer">
										<ChannelFooter />
									</Footer>
									{/*)}*/}
								</>
							)}
					</>
				) : location.pathname !== "/channel" && location.pathname !== "/404" ? (
					<Footer className="footer landing-footer-wrap">
						<FooterComponent />
					</Footer>
				) : (
					<></>
				)}

				{/*{user && accessToken && refreshToken &&*/}
				{/*    <Footer className="footer">*/}
				{/*        <FooterComponent/>*/}
				{/*    </Footer>*/}
				{/*}*/}
			</Layout>
		</>
	);
};

export default PageLayout;
